import ReactGA from 'react-ga4';

import CookieConsent, { resetCookieConsentValue } from "react-cookie-consent";
// console.log(resetCookieConsentValue());


export const GAPurchase = (transactionId, value, currency = "USD", items = [{name: "Platform Credits"}]) => {
    ReactGA.event('purchase', {
        transaction_id: transactionId,
        value: value, // Revenue value in dollars
        currency: currency, // Currency code, e.g., 'USD'
        items: items // Array of items purchased
    });
};

export const GATrackPlatformClick = (platform = 'facebook') => {
    ReactGA.event({
        category: 'Social Links',
        action: 'Click',
        label: platform,
    });
};

export const GAEvent = ReactGA.event;